import React, {
    useEffect,
    forwardRef,
    useRef,
} from "react";
import { useDispatch } from "react-redux";
import { MODALS } from "../organisms/AppModals/modals.constants";
import { checkBlackIcon } from "../../assets/icons";
import { actions as modalActions } from "../organisms/Modal/modal.reducers";

const { setSelectedModal } = modalActions;
const { EDIT_JSON_MODAL } = MODALS;

const JsonEditor = forwardRef(function JsonEditor(props, ref) {
    const dispatch = useDispatch();
    const refInput = useRef();

    useEffect(() => {
        dispatch(setSelectedModal(EDIT_JSON_MODAL));
    }, [dispatch]);

    return (
        <div className="flex items-center w-full h-full bg-white p-2 pl-4 gap-2">
            <input
                ref={refInput}
                className="w-full h-full outline-none border-none text-black text-sm"
                onClick={() => dispatch(setSelectedModal(EDIT_JSON_MODAL))}
            />
            <img
                src={checkBlackIcon}
                alt="check-icon"
                className="w-4 h-4 cursor-pointer"
            />
        </div>
    );
});

export default JsonEditor;
